/**
 * Resolves the leaderboard game mode from user state or localStorage fallback.
 */
export function getLeaderboardSelectedVersion(
    userState: { leaderboardSelectedVersion?: string } | null | undefined,
): string {
    if (userState?.leaderboardSelectedVersion) {
        return userState.leaderboardSelectedVersion;
    }
    try {
        const stored = localStorage.getItem("leaderboardSelectedVersion");
        if (stored) {
            return stored;
        }
    } catch {
        /* ignore */
    }
    return "puzzle";
}

/**
 * Destination for leaderboard "Play Today" / "Keep Playing" based on dropdown selection.
 */
export function getLeaderboardPlayTodayPath(_selectedVersion: string): string {
    // return selectedVersion === "classic" ? "/daily-properties" : "/puzzle";
    return "/";
}
